"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DialogHeader = void 0;
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
const Header = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '120px',
  backgroundColor: theme.palette.common.white,
  fontSize: '3rem',
  marginTop: theme.spacing(1)
}));
const Points = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: theme.typography.pxToRem(74),
  height: theme.typography.pxToRem(74),
  borderRadius: '50%',
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.text.primary,
  lineHeight: theme.typography.pxToRem(74)
}));
const DialogHeader = ({
  points
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(Header, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Points, {
    variant: "h4",
    component: "p",
    align: "center",
    children: points
  })
});
exports.DialogHeader = DialogHeader;
var _default = exports.default = DialogHeader;
